export class ListaAtendimento {
  itens: ItemAtendimento[] = [];
}

export class ItemAtendimento{
  id: number;
  descricao: string;
  dataCadastro: Date;
  solicitante: string;
  descricaoResumida: string;
}
